const US_DATE_FORMAT = new Intl.DateTimeFormat("en-US", {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
});

const US_DATE_TIME_FORMAT = new Intl.DateTimeFormat("en-US", {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

function asCalendarDate(value) {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Display CRM calendar dates as MM/DD/YYYY without changing storage. */
export function formatDateUS(value, fallback = "—") {
  const date = asCalendarDate(value);
  return date ? US_DATE_FORMAT.format(date) : fallback;
}

export function formatDateTimeUS(value, fallback = "—") {
  if (!value) return fallback;
  const normalized = /(?:Z|[+-]\d\d:\d\d)$/.test(String(value)) ? value : `${value}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? fallback : US_DATE_TIME_FORMAT.format(date);
}
